/**
 * Manual Feature types (not part of generated api-models as object is returned as an untyped key/value object)
 */

export type Features = Record<string, boolean>;
export type FeatureFlagValue = string;
export type FeatureFlagKey = string;
export type FeatureFlagEnum = Record<FeatureFlagKey, FeatureFlagValue>;
export enum FeatureFlag {
    AddressLookupEnabled = 'addressLookupEnabled',
    Advisers = 'advisers',
    AllowMessageFileUpload = 'allowMessageFileUpload',
    AllowPowersEditOnAllStatuses = 'allowPowersEditOnAllStatuses',
    AllowProductEditOnAllStatuses = 'allowProductEditOnAllStatuses',
    ArticleDistribution = 'articleDistribution',
    Articles = 'articles',
    ArtificialIntelligence = 'artificialIntelligence',
    ArtificialIntelligenceNewBadge = 'artificialIntelligenceNewBadge',
    AutoAddMinimumSubForm = 'autoAddMinimumSubForm',
    Calendar = 'calendar',
    CaseCharts = 'caseCharts',
    CaseWorkItemMultiSelect = 'caseWorkItemMultiSelect',
    Cases = 'cases',
    ChangeTenant = 'changeTenant',
    ClientCharts = 'clientCharts',
    ClientPortfolioAccounts = 'clientPortfolioAccounts',
    ClientPortfolioAccountTransactions = 'clientPortfolioAccountTransactions',
    ClientPortfolioAssetClasses = 'clientPortfolioAssetClasses',
    ClientPortfolioPerformance = 'clientPortfolioPerformance',
    ClientPortfolioPositions = 'clientPortfolioPositions',
    ClientPortfolioStandingOrders = 'clientPortfolioStandingOrders',
    ClientPortfolioTopMovers = 'clientPortfolioTopMovers',
    ClientPortfolioTransactions = 'clientPortfolioTransactions',
    ClientProductCharts = 'clientProductCharts',
    ClientProductTeamMembersWidgetReadOnly = 'clientProductTeamMembersWidgetReadOnly',
    Clients = 'clients',
    CustomViews = 'customViews',
    Dashboard = 'dashboard',
    DMSCLMiUpload = 'dMSCLMiUpload',
    DMSExternalUpload = 'dMS-CLMi-upload',
    DocumentGenerationAdhoc = 'documentGenerationAdhoc',
    DocumentManagement = 'documentManagement',
    DocumentsPreviewAsPdf = 'documentsPreviewAsPdf',
    DontEncodeIds = 'dontEncodeIds',
    Duplicates = 'duplicates',
    EnableAttachments = 'enableAttachments',
    ESignatureSupport = 'eSignatureSupport',
    Events = 'events',
    Exports = 'exports',
    PortalLockKycFormOnSubmission = 'portalLockKycFormOnSubmission',
    ExternalTasks = 'externalTasks',
    ExternalUserApp = 'externalUserApp',
    ExtractPDF = 'extractPDF',
    FederatedSSO = 'federatedSso',
    Feed = 'feed',
    ForceSearchBeforeEntityCreation = 'forceSearchBeforeEntityCreation',
    GlobalSearch = 'globalSearch',
    ImportAdviser = 'importAdviser',
    ImportIntermediary = 'importIntermediary',
    ImportLead = 'importLead',
    ImportOpportunity = 'importOpportunity',
    ImportProductProvider = 'importProductProvider',
    Imports = 'imports',
    Inbox = 'inbox',
    InboxCharts = 'inboxCharts',
    Intermediaries = 'intermediaries',
    InvestmentDataServices = 'investmentDataServices',
    LeadCharts = 'leadCharts',
    Leads = 'leads',
    Lists = 'lists',
    Marketing = 'marketing',
    MultipleLanguages = 'multipleLanguages',
    NetworkChart = 'networkChart',
    Organisation = 'organisation',
    OrganisationCharts = 'organisationCharts',
    OrganisationConnections = 'organisationConnections',
    PeopleCharts = 'peopleCharts',
    Pipeline = 'pipeline',
    PipelineCharts = 'pipelineCharts',
    PortfolioAccounts = 'portfolioAccounts',
    PortfolioAccountTransactions = 'portfolioAccountTransactions',
    PortfolioAssetClasses = 'portfolioAssetClasses',
    PortfolioPerformance = 'portfolioPerformance',
    PortfolioPositions = 'portfolioPositions',
    PortfolioStandingOrders = 'portfolioStandingOrders',
    PortfolioTopMovers = 'portfolioTopMovers',
    PortfolioTransactions = 'portfolioTransactions',
    PowerBIPortfolio = 'powerBIPortfolio',
    ProductProviders = 'productProviders',
    Products = 'products',
    ProductWidgetShowAssociatedProducts = 'productWidgetShowAssociatedProducts',
    Queues = 'queues',
    Qwil = 'qwil',
    ReferenceDataImportExport = 'referenceDataImportExport',
    SecureMessage = 'secureMessage',
    SendExternalUserInvite = 'sendExternalUserInvite',
    ShowAllRelationshipsOnRelatedClientsWidget = 'showAllRelationshipsOnRelatedClientsWidget',
    TestForms = 'testForms',
    ToastErrors = 'toastErrors',
    TransactionEvidence = 'transactionEvidence',
    Unblu = 'unblu',
}
